'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base = require('../Base');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Copy = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Copy, _Component);

  function Copy() {
    (0, _classCallCheck3.default)(this, Copy);
    return (0, _possibleConstructorReturn3.default)(this, (Copy.__proto__ || (0, _getPrototypeOf2.default)(Copy)).apply(this, arguments));
  }

  (0, _createClass3.default)(Copy, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props, {
        width: parseInt(this.props.width, 10),
        height: parseInt(this.props.height, 10)
      });

      return _react2.default.createElement(
        _Base2.default,
        (0, _extends3.default)({ viewBox: '0 0 445.53 445.529' }, props),
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { fill: props.fillCopy || props.fill, d: 'M395.264,60.6h-81.71V21.184C313.554,9.504,304.049,0,292.37,0H50.265C38.583,0,29.081,9.504,29.081,21.184v342.564   c0,11.68,9.502,21.185,21.185,21.185h81.71v39.413c0,11.68,9.502,21.184,21.185,21.184h242.104c11.68,0,21.185-9.504,21.185-21.184   V81.784C416.449,70.102,406.944,60.6,395.264,60.6z M50.265,366.774c-1.664,0-3.026-1.359-3.026-3.026V21.184   c0-1.669,1.362-3.026,3.026-3.026H292.37c1.667,0,3.026,1.357,3.026,3.026V60.6v303.148c0,1.667-1.359,3.026-3.026,3.026H50.265z    M398.291,424.334c0,1.678-1.359,3.025-3.026,3.025H153.16c-1.664,0-3.026-1.348-3.026-3.025v-38.16H292.37   c11.68,0,21.185-9.505,21.185-21.185v-1.253v-5.172h43.367c5.013,0,9.079-4.061,9.079-9.079s-4.066-9.079-9.079-9.079h-43.367   v-44.384h43.367c5.013,0,9.079-4.061,9.079-9.079c0-5.018-4.066-9.078-9.079-9.078h-43.367V232.47h43.367   c5.013,0,9.079-4.061,9.079-9.079s-4.066-9.079-9.079-9.079h-43.367v-43.604h12.087c5.013,0,9.079-4.061,9.079-9.079   c0-5.019-4.066-9.079-9.079-9.079h-12.087V78.758h81.71c1.667,0,3.026,1.356,3.026,3.026V424.334z M70.929,90.789   c0-5.019,4.066-9.079,9.079-9.079h147.279c5.013,0,9.079,4.061,9.079,9.079c0,5.018-4.066,9.079-9.079,9.079H80.008   C74.996,99.868,70.929,95.807,70.929,90.789z M267.645,152.551c0,5.018-4.066,9.079-9.079,9.079H80.008   c-5.012,0-9.079-4.061-9.079-9.079c0-5.019,4.066-9.079,9.079-9.079h178.558C263.579,143.472,267.645,147.532,267.645,152.551z    M267.645,216.103c0,5.018-4.066,9.079-9.079,9.079H80.008c-5.012,0-9.079-4.061-9.079-9.079s4.066-9.079,9.079-9.079h178.558   C263.579,207.024,267.645,211.085,267.645,216.103z M267.645,278.645c0,5.019-4.066,9.079-9.079,9.079H80.008   c-5.012,0-9.079-4.061-9.079-9.079c0-5.018,4.066-9.078,9.079-9.078h178.558C263.579,269.566,267.645,273.633,267.645,278.645z' })
        )
      );
    }
  }]);
  return Copy;
}(_react.Component), _class.propTypes = {
  width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  height: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  fill: _react.PropTypes.string,
  fillCopy: _react.PropTypes.string,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  width: 16,
  height: 16,
  fill: '#848484'
}, _temp);
exports.default = Copy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseIcons/Copy/Copy.jsx
// module id = 1592
// module chunks = 0